'use client';

import { User } from '@api/models';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';

interface UseAuthenticatedNavigationOptions {
  user: User | null;
}

export function useAuthenticatedNavigation({ user }: UseAuthenticatedNavigationOptions) {
  const router = useRouter();

  const navigateWithAuth = useCallback(
    (targetUrl: string) => {
      // Always navigate to server, let server handle auth redirect
      router.push(targetUrl);
    },
    [router]
  );

  const checkAuthBeforeNavigation = useCallback(
    (_targetUrl: string): boolean => {
      // Simple check: just return if user exists
      // Server-side will handle detailed route protection
      return !!user;
    },
    [user]
  );

  return {
    navigateWithAuth,
    checkAuthBeforeNavigation
  };
}
